<template>
  <div class="w-full">
    <!-- 左侧：合作意向表单 -->
    <div
      class="relative rounded-2xl md:rounded-[32px] p-px scroll-fade-in-left"
      style="background:linear-gradient(135deg, rgba(41, 255, 248, 0.1), rgba(228, 101, 255, 0.1));"
    >
      <div class="relative rounded-2xl md:rounded-[32px] p-4 sm:p-6 md:py-[36px] md:px-[36px] h-full backdrop-blur-sm form-inner-border">
        <form
          @submit.prevent="handleSubmit"
          class="space-y-4 sm:space-y-5 md:space-y-14 mx-0"
          style="font-family: 'Source Han Sans CN', sans-serif;"
        >
          <!-- 投资意向（必填） -->
          <div class="flex items-center flex-wrap gap-3 sm:gap-[55px]">
            <label class="text-white text-base lg:text-[24px] font-medium whitespace-nowrap">
              <span class="text-base lg:text-[24px] font-medium">*</span>投资意向:
            </label>
            <div class="flex flex-wrap gap-3 sm:gap-[60px]">
              <label class="flex items-center cursor-pointer">
                <input
                  v-model="formData.investmentIntent"
                  type="radio"
                  value="20万以下"
                  required
                  class="sr-only"
                >
                <span class="w-4 h-4 lg:w-[26px] lg:h-[26px] border-[#29FFF8] rounded-full border-2 flex items-center justify-center transition-all">
                  <span
                    v-if="formData.investmentIntent === '20万以下'"
                    class="w-2 h-2 sm:w-4 sm:h-4 rounded-full bg-[#29FFF8]"
                  ></span>
                </span>
                <span class="ml-2 text-white text-base lg:text-[18px] font-medium">20万以下</span>
              </label>
              <label class="flex items-center cursor-pointer">
                <input
                  v-model="formData.investmentIntent"
                  type="radio"
                  value="20-50万"
                  required
                  class="sr-only"
                >
                <span class="w-4 h-4 lg:w-[26px] lg:h-[26px] border-[#29FFF8] rounded-full border-2 flex items-center justify-center transition-all">
                  <span
                    v-if="formData.investmentIntent === '20-50万'"
                    class="w-2 h-2 sm:w-4 sm:h-4 rounded-full bg-[#29FFF8]"
                  ></span>
                </span>
                <span class="ml-2 text-white text-base lg:text-[18px] font-medium">20-50万</span>
              </label>
              <label class="flex items-center cursor-pointer">
                <input
                  v-model="formData.investmentIntent"
                  type="radio"
                  value="50万以上"
                  required
                  class="sr-only"
                >
                <span class="w-4 h-4 lg:w-[26px] lg:h-[26px] border-[#29FFF8] rounded-full border-2 flex items-center justify-center transition-all">
                  <span
                    v-if="formData.investmentIntent === '50万以上'"
                    class="w-2 h-2 sm:w-4 sm:h-4 rounded-full bg-[#29FFF8]"
                  ></span>
                </span>
                <span class="ml-2 text-white text-base lg:text-[18px] font-medium">50万以上</span>
              </label>
            </div>
          </div>

          <!-- 开店选址（必填） -->
          <div class="flex items-center flex-wrap gap-3 sm:gap-[55px]">
            <label class="text-white text-base lg:text-[24px] font-medium whitespace-nowrap">
              <span class="text-base lg:text-[24px] font-medium">*</span>开店选址:
            </label>
            <div class="flex flex-wrap gap-3 sm:gap-[60px]">
              <label class="flex items-center cursor-pointer">
                <input
                  v-model="formData.storeLocation"
                  type="radio"
                  value="商场"
                  required
                  class="sr-only"
                >
                <span class="border-[#29FFF8] w-4 h-4 lg:w-[26px] lg:h-[26px] rounded-full border-2 flex items-center justify-center transition-all">
                  <span
                    v-if="formData.storeLocation === '商场'"
                    class="w-2 h-2 sm:w-4 sm:h-4 rounded-full bg-[#29FFF8]"
                  ></span>
                </span>
                <span class="ml-2 text-white text-base lg:text-[18px] font-medium">商场</span>
              </label>
              <label class="flex items-center cursor-pointer">
                <input
                  v-model="formData.storeLocation"
                  type="radio"
                  value="步行街"
                  required
                  class="sr-only"
                >
                <span class="w-4 h-4 lg:w-[26px] lg:h-[26px] border-[#29FFF8] rounded-full border-2 flex items-center justify-center transition-all">
                  <span
                    v-if="formData.storeLocation === '步行街'"
                    class="w-2 h-2 sm:w-4 sm:h-4 rounded-full bg-[#29FFF8]"
                  ></span>
                </span>
                <span class="ml-2 text-white text-base lg:text-[18px] font-medium">步行街</span>
              </label>
              <label class="flex items-center cursor-pointer">
                <input
                  v-model="formData.storeLocation"
                  type="radio"
                  value="商业综合体"
                  required
                  class="sr-only"
                >
                <span class="w-4 h-4 lg:w-[26px] lg:h-[26px] border-[#29FFF8] rounded-full border-2 flex items-center justify-center transition-all">
                  <span
                    v-if="formData.storeLocation === '商业综合体'"
                    class="w-2 h-2 sm:w-4 sm:h-4 rounded-full bg-[#29FFF8]"
                  ></span>
                </span>
                <span class="ml-2 text-white text-base lg:text-[18px] font-medium">商业综合体</span>
              </label>
              <label class="flex items-center cursor-pointer">
                <input
                  v-model="formData.storeLocation"
                  type="radio"
                  value="景区"
                  required
                  class="sr-only"
                >
                <span class="w-4 h-4 lg:w-[26px] lg:h-[26px] border-[#29FFF8] rounded-full border-2 flex items-center justify-center transition-all">
                  <span
                    v-if="formData.storeLocation === '景区'"
                    class="w-2 h-2 sm:w-4 sm:h-4 rounded-full bg-[#29FFF8]"
                  ></span>
                </span>
                <span class="ml-2 text-white text-base lg:text-[18px] font-medium">景区</span>
              </label>
              <label class="flex items-center cursor-pointer">
                <input
                  v-model="formData.storeLocation"
                  type="radio"
                  value="其他"
                  required
                  class="sr-only"
                >
                <span class="w-4 h-4 lg:w-[26px] lg:h-[26px] border-[#29FFF8] rounded-full border-2 flex items-center justify-center transition-all">
                  <span
                    v-if="formData.storeLocation === '其他'"
                    class="w-2 h-2 sm:w-4 sm:h-4 rounded-full bg-[#29FFF8]"
                  ></span>
                </span>
                <span class="ml-2 text-white text-base lg:text-[18px] font-medium">其他</span>
              </label>
            </div>
          </div>

          <!-- 开店面积（必填） -->
          <div class="flex items-center flex-wrap gap-3 sm:gap-[55px]">
            <label class="text-white text-base lg:text-[24px] font-medium whitespace-nowrap">
              <span class="text-base lg:text-[24px] font-medium">*</span>场地面积:
            </label>
            <div class="flex flex-wrap gap-3 sm:gap-[60px]">
              <label class="flex items-center cursor-pointer">
                <input
                  v-model="formData.storeArea"
                  type="radio"
                  value="50平以下"
                  required
                  class="sr-only"
                >
                <span class="w-4 h-4 lg:w-[26px] lg:h-[26px] border-[#29FFF8] rounded-full border-2 flex items-center justify-center transition-all">
                  <span
                    v-if="formData.storeArea === '50平以下'"
                    class="w-2 h-2 sm:w-4 sm:h-4 rounded-full bg-[#29FFF8]"
                  ></span>
                </span>
                <span class="ml-2 text-white text-base lg:text-[18px] font-medium">50平以下</span>
              </label>
              <label class="flex items-center cursor-pointer">
                <input
                  v-model="formData.storeArea"
                  type="radio"
                  value="50-200平"
                  required
                  class="sr-only"
                >
                <span class="w-4 h-4 lg:w-[26px] lg:h-[26px] border-[#29FFF8] rounded-full border-2 flex items-center justify-center transition-all">
                  <span
                    v-if="formData.storeArea === '50-200平'"
                    class="w-2 h-2 sm:w-4 sm:h-4 rounded-full bg-[#29FFF8]"
                  ></span>
                </span>
                <span class="ml-2 text-white text-base lg:text-[18px] font-medium">50-200平</span>
              </label>
              <label class="flex items-center cursor-pointer">
                <input
                  v-model="formData.storeArea"
                  type="radio"
                  value="200平以上"
                  required
                  class="sr-only"
                >
                <span class="w-4 h-4 lg:w-[26px] lg:h-[26px] border-[#29FFF8] rounded-full border-2 flex items-center justify-center transition-all">
                  <span
                    v-if="formData.storeArea === '200平以上'"
                    class="w-2 h-2 sm:w-4 sm:h-4 rounded-full bg-[#29FFF8]"
                  ></span>
                </span>
                <span class="ml-2 text-white text-base lg:text-[18px] font-medium">200平以上</span>
              </label>
            </div>
          </div>

          <!-- 联系信息 - 第一行 -->
          <div class="grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-[55px]">
            <!-- 城市选择（必填） -->
            <div>
              <div class="input-wrapper">
                <select
                  v-model="formData.city"
                  required
                  class="w-full px-4 py-3 bg-[hsla(0,0%,100%,.06)] border border-white/30 rounded-lg text-white placeholder:text-white/50 focus:outline-none focus:border-white/50 focus:bg-[hsla(0,0%,100%,.1)] transition-all appearance-none cursor-pointer"
                  style="background-image: url('data:image/svg+xml;charset=UTF-8,%3csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 24 24\' fill=\'white\'%3e%3cpath d=\'M7 10l5 5 5-5z\'/%3e%3c/svg%3e');
                  border-top:none;border-right:none;
                  background-repeat: no-repeat; background-position: right 0.75rem center; background-size: 1em 1em;"
                >
                  <option
                    value=""
                    disabled
                    class="bg-gray-800 text-white"
                  >*请选择一个城市</option>
                  <option
                    value="北京"
                    class="bg-gray-800 text-white"
                  >北京</option>
                  <option
                    value="上海"
                    class="bg-gray-800 text-white"
                  >上海</option>
                  <option
                    value="广州"
                    class="bg-gray-800 text-white"
                  >广州</option>
                  <option
                    value="深圳"
                    class="bg-gray-800 text-white"
                  >深圳</option>
                  <option
                    value="杭州"
                    class="bg-gray-800 text-white"
                  >杭州</option>
                  <option
                    value="成都"
                    class="bg-gray-800 text-white"
                  >成都</option>
                  <option
                    value="其他"
                    class="bg-gray-800 text-white"
                  >其他</option>
                </select>
              </div>
            </div>
            <!-- 姓名输入（必填） -->
            <div>
              <div class="input-wrapper">
                <input
                  style="border-top:none;border-right:none;"
                  v-model="formData.name"
                  type="text"
                  placeholder="*请输入您的姓名"
                  required
                  class="w-full px-4 py-3 bg-[hsla(0,0%,100%,.06)] border border-white/30 rounded-lg text-white placeholder:text-white/50 focus:outline-none focus:border-white/50 focus:bg-[hsla(0,0%,100%,.1)] transition-all"
                >
              </div>
            </div>
            <!-- 电话输入（必填） -->
            <div>
              <div class="input-wrapper">
                <input
                  style="border-top:none;border-right:none;"
                  v-model="formData.phone"
                  type="tel"
                  placeholder="*请输入您的电话"
                  required
                  class="w-full px-4 py-3 bg-[hsla(0,0%,100%,.06)] border border-white/30 rounded-lg text-white placeholder:text-white/50 focus:outline-none focus:border-white/50 focus:bg-[hsla(0,0%,100%,.1)] transition-all"
                >
              </div>
            </div>
          </div>

          <!-- 需求输入（必填） -->
          <div>
            <div class="input-wrapper-textarea">
              <textarea
                style="border-top:none;border-right:none;"
                v-model="formData.requirement"
                placeholder="*请输入您的需求"
                required
                rows="4"
                class="w-full px-4 py-3 bg-[hsla(0,0%,100%,.06)] border border-white/30 rounded-lg text-white placeholder:text-white/50 focus:outline-none focus:border-white/50 focus:bg-[hsla(0,0%,100%,.1)] transition-all resize-none"
              ></textarea>
            </div>
          </div>

          <!-- 提交按钮 -->
          <div class="flex justify-center mt-6 sm:mt-8">
            <button
              type="submit"
              :disabled="submitting"
              style="background: linear-gradient(135deg, rgba(41, 255, 248, 0.3), rgba(255, 95, 248, 0.3) 100%); font-weight: 400; font-family: 'Source Han Sans CN', sans-serif;"
              class="px-6 sm:px-8 md:px-12 py-3 text-white cursor-pointer text-xs sm:text-sm md:text-xs rounded-lg hover:opacity-90 transition-opacity disabled:opacity-50 disabled:cursor-not-allowed button-inner-border"
            >
              {{ submitting ? '提交中...' : '立即获取盈利方案' }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { contactApi } from "@/api";
import { RequestError } from "@/utils/request";

// 表单数据
const formData = ref({
  investmentIntent: "", // 投资意向
  storeLocation: "", // 开店选址
  storeArea: "", // 开店面积
  city: "", // 城市
  name: "", // 姓名
  phone: "", // 电话
  requirement: "", // 需求
});

// 提交状态
const submitting = ref(false);

// 提交表单
const handleSubmit = async () => {
  // 去除首尾空格
  const investmentIntent = formData.value.investmentIntent?.trim();
  const storeLocation = formData.value.storeLocation?.trim();
  const storeArea = formData.value.storeArea?.trim();
  const city = formData.value.city?.trim();
  const name = formData.value.name?.trim();
  const phone = formData.value.phone?.trim();
  const requirement = formData.value.requirement?.trim();

  // 验证必填项
  if (
    !investmentIntent ||
    !storeLocation ||
    !storeArea ||
    !city ||
    !name ||
    !phone ||
    !requirement
  ) {
    alert("请填写所有必填项");
    return;
  }

  // 验证姓名：2-20个字符
  if (name.length < 2 || name.length > 20) {
    alert("姓名长度应在2-20个字符之间");
    return;
  }

  // 验证电话号码：支持手机号（11位，1开头）或座机号（区号+号码）
  const phoneRegex = /^(1[3-9]\d{9}|0\d{2,3}-?\d{7,8})$/;
  if (!phoneRegex.test(phone)) {
    alert("请输入有效的电话号码（手机号或座机号）");
    return;
  }

  submitting.value = true;
  try {
    const response = await contactApi.submitJoinForms({
      investmentBudget: investmentIntent,
      storeLocation,
      storeArea,
      city,
      contactName: name,
      contactPhone: phone,
      inquiryContent: requirement,
    });

    if (response.code === 200 || response.success) {
      alert("申请已提交，请等待客服与您沟通");
      // 清空表单
      formData.value = {
        investmentIntent: "",
        storeLocation: "",
        storeArea: "",
        city: "",
        name: "",
        phone: "",
        requirement: "",
      };
    } else {
      alert(response.message || "提交失败，请稍后重试");
    }
  } catch (error) {
    console.error("提交表单失败:", error);
    if (error instanceof RequestError) {
      alert(error.message || "提交失败，请稍后重试");
    } else {
      alert("提交失败，请稍后重试");
    }
  } finally {
    submitting.value = false;
  }
};
</script>

<style scoped>
.input-wrapper {
  position: relative;
}

.input-wrapper::before {
  content: "";
  position: absolute;
  top: 2px;
  left: 0;
  width: 2px;
  bottom: 2px;
  background: linear-gradient(180deg, #4a90e2, #4a90e2);
  pointer-events: none;
  border-radius: 2rem;
}

.input-wrapper::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background: linear-gradient(90deg, #4a90e2, #f161f9);
  opacity: 1;
  pointer-events: none;
  border-radius: 0 0 2rem 2rem;
}

.input-wrapper-textarea {
  position: relative;
}

.input-wrapper-textarea::before {
  content: "";
  position: absolute;
  top: 2px;
  left: 0;
  width: 2px;
  bottom: 4px;
  background: linear-gradient(180deg, #4a90e2, #4a90e2);
  pointer-events: none;
  border-radius: 2rem;
}

.input-wrapper-textarea::after {
  content: "";
  position: absolute;
  bottom: 4px;
  left: 0;
  width: 100%;
  height: 2px;
  background: linear-gradient(90deg, #4a90e2, #f161f9);
  opacity: 1;
  pointer-events: none;
  border-radius: 0 0 2rem 0;
}

.form-inner-border {
  position: relative;
}

.form-inner-border::before {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: inherit;
  padding: 1px;
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 1),
    rgba(255, 255, 255, 0)
  );
  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  mask-composite: exclude;
  pointer-events: none;
  z-index: 1;
}

.button-inner-border {
  position: relative;
}

.button-inner-border::before {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: inherit;
  padding: 1px;
  background: linear-gradient(
    135deg,
    rgba(69, 128, 255, 1),
    rgba(255, 95, 248, 1)
  );
  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  mask-composite: exclude;
  pointer-events: none;
  z-index: 1;
}
</style>
